// Filtre global de territoire (barre supérieure) : appliqué à la carte, aux listes d'installations et à la
// recherche de l'accueil. Conservé pour la durée de la session de navigation.

import { createContext, useContext, useState, type ReactNode } from 'react';

interface FiltresGlobaux {
  province: string | null;
  definirProvince: (code: string | null) => void;
}

const Contexte = createContext<FiltresGlobaux | null>(null);
const CLE = 'ct-filtre-province';

function lireInitial(): string | null {
  try {
    return sessionStorage.getItem(CLE);
  } catch {
    return null;
  }
}

export function FournisseurFiltres({ children }: { children: ReactNode }) {
  const [province, setProvince] = useState<string | null>(lireInitial);
  const definirProvince = (code: string | null) => {
    setProvince(code);
    try {
      if (code) sessionStorage.setItem(CLE, code);
      else sessionStorage.removeItem(CLE);
    } catch {
      // Sans conséquence.
    }
  };
  return <Contexte.Provider value={{ province, definirProvince }}>{children}</Contexte.Provider>;
}

export function useFiltres(): FiltresGlobaux {
  const v = useContext(Contexte);
  if (!v) throw new Error('useFiltres hors du fournisseur');
  return v;
}
